// extracted by mini-css-extract-plugin
module.exports = {"sliderSlides":"styles_sliderSlides__2k6Vu","activeSlide":"styles_activeSlide__aLUDk","nextSlide":"styles_nextSlide__wzj_m"};